window.SiteReady(($) => {

  console.log('Init Block: Benefits');

  let $benefit_blocks = $('.js-benefits');

  $benefit_blocks.each((index, item) => {
    let $benefit_block = $(item);
    let $benefits = $benefit_block.find('.benefit');

    $benefits.each((index, item) => {
      let $benefit = $(item);

      $benefit.on('swap:activate swap:deactivate', function() {
        let active_benefits = $benefits.filter('.fs-swap-active');

        if ( active_benefits.length > 0 ) {
          $benefit_block.addClass('benefit-open');
        } else {
          $benefit_block.removeClass('benefit-open');
        }
      });
    });
  });


});